import * as roles from '../access/roles';

export default class UserParamsFormatter {
    static format(formFields) {
        formFields = {...formFields};
        formFields.roles = [];
        if(+formFields.companyId) {
            formFields.roles.push(roles.PARTNER_ROLE);
        }

        if(formFields.isAdmin) {
            formFields.roles.push(roles.FBG_WEBMASTER);
        }

        return formFields;
    }
}


// WEBPACK FOOTER //
// ./web/src/services/user/UserParamsFormatter.js